import React from "react";

import useDoctorChart from "components/pages/dashboard/doctor_analytic/chart/useDoctorChart";
import BarChart from "../../chart/BarChart";

const DoctorChart = ({ data, filter }) => {
  const { options, chartData } = useDoctorChart(data, filter);

  return (
    <div style={{ position: "relative" }}>
      <BarChart
        options={options}
        height={100}
        data={chartData}
        style={{ cursor: "pointer" }}
      />
    </div>
  );
};

export default DoctorChart;
